// extracted by mini-css-extract-plugin
module.exports = {"item":"styles_item__VifKY","arrowRight":"styles_arrowRight__D6KI9"};